/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input, ViewChild } from "@angular/core";
import {
	ControlContainer,
	ControlValueAccessor,
	FormControl,
	FormControlDirective,
	NG_VALUE_ACCESSOR
} from "@angular/forms";
import { SelectPillOptions } from "./types";

@Component({
	selector: "app-select-pill",
	templateUrl: "./select-pill.component.html",
	styleUrls: ["./select-pill.component.scss"],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: SelectPillComponent,
			multi: true
		}
	],
	standalone: false
})
export class SelectPillComponent implements ControlValueAccessor {
	@Input()
	options!: SelectPillOptions[];
	@Input()
	formControlName = "";

	@Input()
	isDisabled = false;

	protected pseudoRandomId = `${Math.random()}${Date.now()}`;

	@ViewChild(FormControlDirective, { static: true })
	formControlDirective!: FormControlDirective;

	constructor(private controlContainer: ControlContainer) {}

	registerOnTouched(fn: any): void {
		this.formControlDirective?.valueAccessor?.registerOnTouched(fn);
	}

	registerOnChange(fn: any): void {
		this.formControlDirective?.valueAccessor?.registerOnChange(fn);
	}

	writeValue(obj: any): void {
		this.formControlDirective?.valueAccessor?.writeValue(obj);
	}

	get control() {
		return this.controlContainer.control?.get(
			this.formControlName
		) as FormControl;
	}
}
